// extracted by mini-css-extract-plugin
module.exports = {"value":"cardCompare_value__1rkDx"};